import service from '@/store/services/settings/neighborhoods-service';

const state = {
    list: {},
    neighborhood: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, neighborhood) => {
        state.neighborhood = neighborhood;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(neighborhood => {
                commit('SET_RESOURCE', neighborhood);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(neighborhood => {
                commit('SET_RESOURCE', neighborhood);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((neighborhood) => {
                commit('SET_RESOURCE', neighborhood);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((neighborhood) => {
                commit('SET_RESOURCE', neighborhood);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    neighborhood: state => state.neighborhood,
    dropdown: (state) => {
        return state.list.map(neighborhood => ({
            id: neighborhood.id,
        }));
    }
};

const neighborhoods = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default neighborhoods;
